import React from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ExperienceSection({ form, setForm }) {
  const handleChange = (index, field, value) => {
    const updated = [...form.experiences];
    updated[index][field] = value;
    setForm({ ...form, experiences: updated });
  };

  const handleAdd = () => {
    setForm({
      ...form,
      experiences: [
        ...form.experiences,
        {
          company: "",
          position: "",
          start_date: "",
          end_date: "",
          description: "",
        },
      ],
    });
  };

  const handleRemove = (index) => {
    const updated = form.experiences.filter((_, i) => i !== index);
    setForm({ ...form, experiences: updated });
  };

  return (
    <Box className="candidate-section">
      <Box className="candidate-section-head">
        <Typography className="candidate-section-kicker">Section 2</Typography>
        <Typography className="candidate-section-title">Experience</Typography>
        <Typography className="candidate-section-subtitle">
          Add previous roles and summarize measurable contributions.
        </Typography>
      </Box>

      {form.experiences.length === 0 ? (
        <Box className="candidate-empty-state">
          <Typography>No experience added yet.</Typography>
        </Box>
      ) : null}

      {form.experiences.map((exp, index) => (
        <Box key={index} className="candidate-entry-card">
          <Box className="candidate-entry-top">
            <Typography className="candidate-entry-title">
              Experience {index + 1}
            </Typography>
            <IconButton
              type="button"
              onClick={() => handleRemove(index)}
              className="candidate-remove-btn"
            >
              <DeleteIcon />
            </IconButton>
          </Box>

          <Box className="candidate-grid two-col">
            <TextField
              fullWidth
              label="Company"
              value={exp.company}
              onChange={(e) => handleChange(index, "company", e.target.value)}
            />
            <TextField
              fullWidth
              label="Position"
              value={exp.position}
              onChange={(e) => handleChange(index, "position", e.target.value)}
            />
            <TextField
              fullWidth
              label="Start Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={exp.start_date}
              onChange={(e) => handleChange(index, "start_date", e.target.value)}
            />
            <TextField
              fullWidth
              label="End Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={exp.end_date}
              onChange={(e) => handleChange(index, "end_date", e.target.value)}
            />
          </Box>

          <Box sx={{ mt: 1.5 }}>
            <TextField
              fullWidth
              multiline
              label="Description"
              rows={3}
              value={exp.description}
              onChange={(e) => handleChange(index, "description", e.target.value)}
            />
          </Box>
        </Box>
      ))}

      <Button type="button" variant="outlined" onClick={handleAdd} className="candidate-add-btn">
        Add Experience
      </Button>
    </Box>
  );
}
